import styled from "styled-components";

export const Container = styled.div`
  padding: 5rem 5rem;
  @media screen and (max-width: 414px) {
    padding: 3rem 3rem;
  }
  z-index: 999;
`;
export const Container2 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1;
  width: 100%;
  height: fit-content;
  max-width: 1040px;
  margin: 0 auto;
`;
export const Header = styled.header`
  text-align: center;
  font-size: 2rem;
  color: #071242;
  font-weight: 700;
  margin-bottom: 5rem;
`;
